import { useEffect, useRef, useState } from 'react';
import useInitConversation from '@/widget/ui/hooks/useInitConversation';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { useStore } from 'zustand';

export default function usePopupMessage() {
  const { store, settings } = useChatWidgetContext();
  const {
    invitationText,
    quickAnswers,
    customTrigger,
  } = settings;

  const touched = useStore(store, (state) => state.touched);
  const contactId = useStore(store, (state) => state.contactId);

  const { setTouched, setTemplateToStart, setOpen } = store.getState();

  const invitationTimeout = useRef(null);
  const { initConversation } = useInitConversation();
  const [displayInvitation, setDisplayInvitation] = useState(false);

  function startConversation(message = null) {
    setTouched(true);
    if (message) { setTemplateToStart(message); }
    initConversation();
    setOpen(true);
  }

  useEffect(() => {
    if (invitationTimeout.current) { clearTimeout(invitationTimeout.current); }
    if (customTrigger || contactId || touched) {
      setDisplayInvitation(false);
    } else if (invitationText) {
      invitationTimeout.current = setTimeout(() => setDisplayInvitation(true), 10_000);
    }

    return () => {
      if (invitationTimeout.current) { clearTimeout(invitationTimeout.current); }
    };
  }, [contactId, customTrigger, invitationText, touched]);

  return {
    quickAnswers,
    invitationText,
    setTouched,
    displayInvitation,
    startConversation,
  };
}
